import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';

const PersistenceManager: React.FC = () => {
  const { refreshToken, token } = useAuth();

  useEffect(() => {
    // Vérifier périodiquement si le token est toujours valide
    const checkTokenValidity = async () => {
      if (token) {
        try {
          // Tenter de rafraîchir le token pour vérifier sa validité
          await refreshToken();
        } catch (error) {
          // Si le rafraîchissement échoue, l'utilisateur sera automatiquement déconnecté
          console.log('Token expiré, déconnexion automatique');
        }
      }
    };

    // Vérifier toutes les 30 minutes
    const interval = setInterval(checkTokenValidity, 30 * 60 * 1000);

    return () => clearInterval(interval);
  }, [token, refreshToken]);

  return null; // Ce composant ne rend rien
};

export default PersistenceManager;